// import * as z from "zod"
import * as z from "zod/v4";
const allowedDomains = ["centivo.com"];

const logInSchema = z.object({
    email: z.string({ required_error: "Name is required" }).min(3, { message: "Invalid Name" }),
    // z
    //     .email({
    //         message: "Invalid email address",
    //         // error: (issue) => issue.input === undefined
    //         //     ? "This field is required"
    //         //     : "Not a string"
    //     })
    // .refine((email) => {
    //     const domain = email.split("@")[1]?.toLowerCase();
    //     return allowedDomains.includes(domain);
    // }, {
    //     message: "Email domain is not allowed",
    // })
});

const benefitPlanMultiStepFormCreate = z.object({
    draftId: z.string(), //.default(crypto.randomUUID()),
    asOfDate: z.date("Date is required"),
    account: z.object(
        {
            label: z.string().describe("accountName"),
            value: z.string().describe("accountHccId"),
        },
        {
            error: (iss) => {
                // console.log('iss', iss);
                if (iss.code === "invalid_type") {
                    return "Account is required";
                }

                return "Account is required";
            },
        }
    ),
    product: z.object(
        {
            label: z.string().describe("productName"),
            value: z.string().describe("productHccId"),
        },
        {
            error: (iss) => {
                // console.log('iss', iss);
                if (iss.code === "invalid_type") {
                    return "Product is required";
                }

                return "Product is required";
            },
        }
    ),
    template: z.object(
        {
            label: z.string().describe("benefitPlanTemplateName from the tool response"),
            value: z.number().describe("benefitPlanTemplateKey from the tool response"),
        },
        {
            error: (iss) => {
                // console.log('iss', iss);
                if (iss.code === "invalid_type") {
                    return "Template is required";
                }

                return "Template is required";
            },
        }
    ),
    benefitPlanName: z.string({ required_error: "Name is required" }).min(3, { message: "Invalid Name" }),
    benefitPlanHccId: z.string({ required_error: "HCC ID is required" }).min(3, { message: "Invalid HCC ID" }),
    benefitPlanDesc: z.string().optional().describe("summary of plan"),
    // isHighDeductiblePlan: z.boolean().default(false),
    // coverageTeir: z.object({
    //     label: z.string().describe('coverageTeir from the tool response'),
    //     value: z.number().describe('coverageTeir from the tool response'),
    // }, {
    //     error: (iss) => {
    //         // console.log('iss', iss);
    //         if (iss.code === 'invalid_type') {
    //             return 'Coverage Teir is required'
    //         }

    //         return 'Coverage Teir is required'
    //     }
    // }),
    // dependentAgeOutPolicy: z.number(), //.default(26),
    effectiveStartDate: z.iso
        .date({
            error: (iss) => {
                return "Start date  is required";
            },
            // error: (iss) => {
            //     // console.log('iss', iss);
            //     if (iss.code === 'invalid_format') {
            //         return "StartDate  is required",
            //     }

            //     return "StartDate  is required",
            // }
        })
        .describe("Plan start date"),



    // effectiveEndDate: z.iso.date({
    //     required_error: "End Date  is required",
    //     invalid_type_error: "EndDate  must be a valid date",
    // }).describe('plan end date'),
    // planStartMonthday: z.date({
    //     error: (iss) => {
    //         return "Accum reset date  is required"
    //     }
    //     // error: (iss) => {
    //     //     // console.log('iss', iss);
    //     //     if (iss.code === 'invalid_format') {
    //     //         return "StartDate  is required",
    //     //     }

    //     //     return "StartDate  is required",
    //     // }
    // }).describe('Accum start date'),

    // anniversaryDate: z.object({
    //     firstRenewalDate: z.string(),
    //     renewalInterval: z.number()
    // }),
    // accountPlanSelections: z.object({
    //     startDate: z.coerce.date(),
    //     endDate: z.coerce.date(),
    //     id: z.object({
    //         codeEntry: z.string(),
    //         shortName: z.string()
    //     })
    // })
});

const benefitPlanMultiStepFormUpdate = z
    .object({
        ...benefitPlanMultiStepFormCreate.shape,
        shouldOverridePlanYearDate: z.boolean().nullish(),
        planYearDateOverride: z.object({
            planYearStartDateOverride: z.date().optional().nullish(),
            planYearEndDateOverride: z.date().optional().nullish(),
        }).optional().nullish(),
        // .refine((data) => {
        //         console.log(`refine date: ${!data.planYearStartDateOverride || data.planYearEndDateOverride > data.planYearStartDateOverride}`, data)
        //         return !data.planYearStartDateOverride || data.planYearEndDateOverride > data.planYearStartDateOverride
        //     },
        //         {
        //             message: "Invalid date",
        //             path: ["planYearEndDateOverride"],
        //         }),
        valueList: z.object(
            {
                label: z.string().optional().describe("Value List from the tool response"),
                value: z.string().optional().describe("Value List from the tool response"),
            },
            {
                error: (iss) => {
                    if (iss.code === "invalid_type") {
                        return "Value List is required";
                    }

                    return "Value List is required";
                },
            }
        ).optional(),
    })
    .refine((data) => {
        return !data.shouldOverridePlanYearDate || !!(data.shouldOverridePlanYearDate &&
            data.planYearDateOverride?.planYearEndDateOverride &&
            data.planYearDateOverride?.planYearStartDateOverride &&
            data.planYearDateOverride?.planYearEndDateOverride > data.planYearDateOverride?.planYearStartDateOverride) //if value is  false it will be disabled 
        //  if (!data.shouldOverridePlanYearDate) return true
        // if (!!data.planYearDateOverride?.planYearStartDateOverride) return false
        // if (data.planYearDateOverride?.planYearEndDateOverride > data.planYearDateOverride?.planYearStartDateOverride) return true
    },
        {
            path: ["planYearDateOverride"],
            message: 'Invalid value'
        }
    )


const benefitPlanSchema = z
    .object({
        // draftId: z.string().default(crypto.randomUUID()),
        account: z
            .object(
                {
                    label: z.string().describe("accountName"),
                    value: z.string().describe("accountHccId"),
                },
                {
                    error: (err) => {
                        console.log({ err });
                    },
                }
            )
            .catchall((e) => {
                console.log("catchall", e);
            }),
        benefitPlanName: z.string({ required_error: "Name is required" }).min(3, { message: "Invalid Name" }),
        benefitPlanDesc: z.string().describe("summary of plan"),
        // benefitPlanTemplateName: z.string(),
        template: z.object({
            label: z.string().describe("benefitPlanTemplateName from the tool response"),
            value: z.string().describe("benefitPlanTemplateName from the tool response"),
        }),
        // selectedBenefitPlanTemplateName: z.object({
        //     value: z.string(),
        //     label: z.string(),
        // }).nullable().refine(val => val !== null, 'Please select an option'),
        effectiveStartDate: z.iso
            .date({
                required_error: "StartDate  is required",
                invalid_type_error: "StartDate  must be a valid date",
            })
            .describe("Plan start date"),
        effectiveEndDate: z.iso
            .date({
                required_error: "End Date  is required",
                invalid_type_error: "EndDate  must be a valid date",
            })
            .describe("plan end date"),
        planStartMonthday: z.object({
            planStartMonth: z
                .string()
                .regex(/^\d{4}-\d{2}$/, "Invalid date format, expected YYYY-MM")
                .describe("year and month only in YYYY-MM format"),
            planStartDay: z.number(),
        }),
        // planStartMonthday: z.object({
        //     planStartMonth: z.string()
        //     // planStartMonth: z.string().regex(
        //     //     /^\d{4}-\d{2}$/,
        //     //     "Date must be in YYYY-MM format (e.g., 2025-07)"
        //     // ).refine((val) => {
        //     //     const [year, month] = val.split('-').map(Number);
        //     //     // Basic validation: year should be reasonable, month between 1 and 12
        //     //     return year >= 1900 && year <= 2100 && month >= 1 && month <= 12;
        //     // }, "Invalid year or month."),
        //     // planStartDay: z.number().describe('start of the month')
        // }),
        //  isHighDeductiblePlan: z.boolean().default(false),
        // anniversaryDate: z.object({
        //     firstRenewalDate: z.string(),
        //     renewalInterval: z.number()
        // }),
        // accountPlanSelections: z.object({
        //     startDate: z.coerce.date(),
        //     endDate: z.coerce.date(),
        //     id: z.object({
        //         codeEntry: z.string(),
        //         shortName: z.string()
        //     })
        // })
    })
    .refine((data) => data.effectiveEndDate > data.effectiveStartDate, {
        message: "End Date must be after start date",
        path: ["effectiveEndDate"], // This indicates where the error should be attached
    });

const isBlank = (v) => v == null || (typeof v === "string" && v.trim() === "");

const doesDraftHaveAnyInput = (draft) => {
    if (!draft) return false;
    return (
        !isBlank(draft.parentAccount?.value) ||
        !isBlank(draft.accountName) ||
        !isBlank(draft.accountHccId) ||
        !isBlank(draft.accountType?.value) ||
        !isBlank(draft.primaryAddress1) ||
        !isBlank(draft.primaryAddress2) ||
        !isBlank(draft.primaryAddress3) ||
        !isBlank(draft.primaryAddressCity) ||
        !isBlank(draft.primaryAddressState?.value) ||
        !isBlank(draft.primaryAddressZip) ||
        !isBlank(draft.billingCycle?.value) ||
        !isBlank(draft.billingAddress1) ||
        !isBlank(draft.billingAddress2) ||
        !isBlank(draft.billingAddress3) ||
        !isBlank(draft.billingAddressCity) ||
        !isBlank(draft.billingAddressState?.value) ||
        !isBlank(draft.billingAddressZip)
    );
};

const subAccountDraftSchema = z
    .object({
        parentAccount: z.object({
            key: z.string().optional(),
            label: z.string().optional(),
            value: z.string().optional(),
        }).optional(),
        accountName: z.string().optional(),
        accountHccId: z.string().optional(),
        accountType: z.object({
            label: z.string().optional(),
            value: z.string().optional(),
        }).optional(),
        subscriptionsAllowed: z.boolean().nullish(),
        ignorePrimaryAddressCheck: z.boolean().nullish(),
        primaryAddress1: z.string().optional(),
        primaryAddress2: z.string().nullish(),
        primaryAddress3: z.string().nullish(),
        primaryAddressCity: z.string().optional(),
        primaryAddressState: z.object({
            label: z.string().optional(),
            value: z.string().optional(),
        }).optional(),
        primaryAddressZip: z.string().optional(),
        billParent: z.boolean().nullish(),
        billingCycle: z.object({
            label: z.string().optional(),
            value: z.number().optional(),
        }).optional(),
        ignoreBillingAddressCheck: z.boolean().nullish(),
        billingAddress1: z.string().optional(),
        billingAddress2: z.string().nullish(),
        billingAddress3: z.string().nullish(),
        billingAddressCity: z.string().optional(),
        billingAddressState: z.object({
            label: z.string().optional(),
            value: z.string().optional(),
        }).optional(),
        billingAddressZip: z.string().optional(),
    })
    .superRefine((draft, ctx) => {
        if (!doesDraftHaveAnyInput(draft)) return;

        const req = (path, message) => {
            ctx.addIssue({ code: "custom", path, message });
        };

        if (isBlank(draft.parentAccount?.value)) req(["parentAccount"], "Parent account is required");
        if (isBlank(draft.accountName)) {
            req(["accountName"], "Name is required");
        } else if (draft.accountName?.length < 3) {
            req(["accountName"], "Invalid Name");
        }
        if (isBlank(draft.accountHccId)) {
            req(["accountHccId"], "HCC ID is required");
        } else if (draft.accountHccId?.length < 3) {
            req(["accountHccId"], "Invalid HCC ID");
        }
        if (isBlank(draft.accountType?.value)) req(["accountType"], "Account type is required");

        if (isBlank(draft.primaryAddress1)) req(["primaryAddress1"], "Address is required");
        if (isBlank(draft.primaryAddressCity)) req(["primaryAddressCity"], "City is required");
        if (isBlank(draft.primaryAddressState?.value)) req(["primaryAddressState"], "State is required");
        if (isBlank(draft.primaryAddressZip)) {
            req(["primaryAddressZip"], "Zip code is required");
        } else {
            if (draft.primaryAddressZip?.length !== 5) req(["primaryAddressZip"], "Invalid Zip Code");
            if (!/^\d+$/.test(draft.primaryAddressZip ?? '')) req(["primaryAddressZip"], "Invalid Zip Code");
        }

        if (!draft.billParent) {
            if (isBlank(draft.billingCycle?.value)) req(["billingCycle"], "Billing cycle is required");
            if (isBlank(draft.billingAddress1)) req(["billingAddress1"], "Address is required");
            if (isBlank(draft.billingAddressCity)) req(["billingAddressCity"], "City is required");
            if (isBlank(draft.billingAddressState?.value)) req(["billingAddressState"], "State is required");
            if (isBlank(draft.billingAddressZip)) {
                req(["billingAddressZip"], "Zip code is required");
            } else {
                if (draft.billingAddressZip?.length !== 5) req(["billingAddressZip"], "Invalid Zip Code");
                if (!/^\d+$/.test(draft.billingAddressZip ?? '')) req(["billingAddressZip"], "Invalid Zip Code");
            }
        }
    });

const subAccountSchema = z
    .object({
        parentAccount: z.object({
            key: z.string(),
            label: z.string(),
            value: z.string().nonempty("Parent account is required"),
        }),
        accountName: z.string().trim().nonempty("Name is required").min(3, { message: "Invalid Name" }),
        accountHccId: z.string().trim().nonempty("HCC ID is required").min(3, { message: "Invalid HCC ID" }),
        accountType: z.object({
            label: z.string(),
            value: z.string().nonempty("Account type is required"),
        }),
        subscriptionsAllowed: z.boolean().nullish(),
        ignorePrimaryAddressCheck: z.boolean().nullish(),
        primaryAddress1: z.string().trim().nonempty("Address is required"),
        primaryAddress2: z.string().nullish(),
        primaryAddress3: z.string().nullish(),
        primaryAddressCity: z.string().trim().nonempty("City is required"),
        primaryAddressState: z.object({
            label: z.string(),
            value: z.string().nonempty("State is required"),
        }),
        primaryAddressZip: z.string().trim().nonempty("Zip code is required").length(5, "Invalid Zip Code").regex(/^\d+$/, "Invalid Zip Code"),
        billParent: z.boolean().nullish(),
        billingCycle: z.object({
            label: z.string(),
            value: z.number(),
        }, { required_error: "Billing cycle is required" }),
        ignoreBillingAddressCheck: z.boolean().nullish(),
        billingAddress1: z.string().trim().nonempty("Address is required"),
        billingAddress2: z.string().nullish(),
        billingAddress3: z.string().nullish(),
        billingAddressCity: z.string().trim().nonempty("City is required"),
        billingAddressState: z.object({
            label: z.string(),
            value: z.string().nonempty("State is required"),
        }),
        billingAddressZip: z.string().trim().nonempty("Zip code is required").length(5, "Invalid Zip Code").regex(/^\d+$/, "Invalid Zip Code"),
    });

const udtsSchema = z
    .object({
        enableInvoiceInformation: z.boolean().nullish(),
        enableFundingMode: z.boolean().nullish(),
        enableAccountMigrationDate: z.boolean().nullish(),
        enableNysHcra: z.boolean().nullish(),
        enableRiskSharing: z.boolean().nullish(),
        enableChannelPartner: z.boolean().nullish(),
        invoiceType: z.object({
            label: z.string().nullish(),
            value: z.string().nullish(),
        }).nullish(),
        paymentRemit: z.object({
            label: z.string().nullish(),
            value: z.string().nullish(),
        }).nullish(),
        purchaseOrder: z.string().nullish(),
        fundingMode: z.object({
            label: z.string().nullish(),
            value: z.string().nullish(),
        }).nullish(),
        accountMigrationDate: z.iso.date().nullish(),
        nysHcra: z.object({
            label: z.string().nullish(),
            value: z.string().nullish(),
        }).nullish(),
        nysHcraDate: z.iso.date().nullish(),
        nysHcraNotes: z.string().nullish(),
        riskSharing: z.object({
            label: z.string().nullish(),
            value: z.string().nullish(),
        }).nullish(),
        channelPartner: z.object({
            label: z.string().nullish(),
            value: z.string().nullish(),
        }).nullish(),
    })
    .superRefine((udts, ctx) => {
        const req = (path, message) => {
            ctx.addIssue({ code: "custom", path, message });
        };

        if (udts.enableInvoiceInformation) {
            if (isBlank(udts.invoiceType?.value)) req(["invoiceType"], "Invoice type is required");
            if (isBlank(udts.paymentRemit?.value)) req(["paymentRemit"], "Payment remit information is required");
            if (isBlank(udts.purchaseOrder)) req(["purchaseOrder"], "Purchase order is required");
        }
        if (udts.enableFundingMode) {
            if (isBlank(udts.fundingMode?.value)) req(["fundingMode"], "Funding mode is required");
        }
        if (udts.enableNysHcra) {
            if (isBlank(udts.nysHcra?.value)) req(["nysHcra"], "Election type is required");
            if (isBlank(udts.nysHcraNotes)) req(["nysHcraNotes"], "Election notes are required");
        }
        if (udts.enableRiskSharing) {
            if (isBlank(udts.riskSharing?.value)) req(["riskSharing"], "Risk sharing is required");
        }
        if (udts.enableChannelPartner) {
            if (isBlank(udts.channelPartner?.value)) req(["channelPartner"], "Channel partner is required");
        }
    });

const accountSchema = z.object({
    asOfDate: z.date({ required_error: "Date is required" }),
    updateAllVersions: z.boolean().nullish(),
    taxEntity: z.object({
        label: z.string(),
        value: z.string().nonempty("Tax entity is required"),
    }),
    accountName: z.string().trim().nonempty("Name is required").min(3, { message: "Invalid Name" }),
    accountHccId: z.string().trim().nonempty("HCC ID is required").min(3, { message: "Invalid HCC ID" }),
    accountType: z.object({
        label: z.string(),
        value: z.string().nonempty("Account type is required"),
    }),
    effectiveDate: z.iso.date({ required_error: "Start date is required" }).describe("Account start date"),
    renewalInterval: z.number({ required_error: "Interval is required" }).min(1, "Invalid Interval").max(12, "Invalid Interval"),
    subscriptionsAllowed: z.boolean().nullish(),
    ignorePrimaryAddressCheck: z.boolean().nullish(),
    primaryAddress1: z.string().trim().nonempty("Address is required"),
    primaryAddress2: z.string().nullish(),
    primaryAddress3: z.string().nullish(),
    primaryAddressCity: z.string().trim().nonempty("City is required"),
    primaryAddressState: z.object({
        label: z.string(),
        value: z.string().nonempty("State is required"),
    }),
    primaryAddressZip: z.string().trim().nonempty("Zip code is required").length(5, "Invalid Zip Code").regex(/^\d+$/, "Invalid Zip Code"),
    billingCycle: z.object({
        label: z.string(),
        value: z.number(),
    }, { required_error: "Billing cycle is required" }),
    ignoreBillingAddressCheck: z.boolean().nullish(),
    billingAddress1: z.string().trim().nonempty("Address is required"),
    billingAddress2: z.string().nullish(),
    billingAddress3: z.string().nullish(),
    billingAddressCity: z.string().trim().nonempty("City is required"),
    billingAddressState: z.object({
        label: z.string(),
        value: z.string().nonempty("State is required"),
    }),
    billingAddressZip: z.string().trim().nonempty("Zip code is required").length(5, "Invalid Zip Code").regex(/^\d+$/, "Invalid Zip Code"),
    subAccountDraft: subAccountDraftSchema,
    subAccounts: z.array(subAccountSchema).default([]),
    udts: udtsSchema,
});

export { benefitPlanSchema, benefitPlanMultiStepFormCreate, benefitPlanMultiStepFormUpdate, logInSchema, accountSchema, doesDraftHaveAnyInput };
